import { WrenchIcon } from "@visma-netvisor/nv-react-icons";
import { Button, EmptyState } from "@visma-netvisor/react-component-library";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { PRICING_PAGE_URL } from "../constants";

interface IProps {
  isMaintenance: any;
}

export const Maintenance = ({ isMaintenance }: IProps) => {
  const { t } = useTranslation();

  return (
    <EmptyState
      actions={
        <>
          <Button
            onClick={() =>
              (window.location.href = PRICING_PAGE_URL)
            }
          >
            {t("General.Back")}
          </Button>
        </>
      }
      description={
        <span>
          {t("Errors.Maintenance.Message", {
            startTime: isMaintenance.startTime,
            endTime: isMaintenance.endTime,
          })}
          <br />
          <StyledLink href="https://netvisor.fi/tuote/yhteydenotto/">
            {t("Errors.Maintenance.ContactLink")}
          </StyledLink>
        </span>
      }
      heading={t("Errors.Maintenance.Title")}
      icon={WrenchIcon}
    />
  );
};

const StyledLink = styled.a`
  text-decoration: none;
`;
